(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagnalog_tipoDetailController', Campagnalog_tipoDetailController);

    Campagnalog_tipoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Campagnalog_tipo'];

    function Campagnalog_tipoDetailController($scope, $rootScope, $stateParams, previousState, entity, Campagnalog_tipo) {
        var vm = this;

        vm.campagnalog_tipo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:campagnalog_tipoUpdate', function(event, result) {
            vm.campagnalog_tipo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
